import * as React from "react";
import ReactGA from "react-ga4";

const GAContext = React.createContext();
GAContext.displayName = "GAContext";

let gtagID = process.env.REACT_APP_GTAG;

function GAProvider(props) {
  const ga_initialize = React.useCallback(() => {
    if (process.env.NODE_ENV !== "test") {
      if (ReactGA) {
        ReactGA.initialize([
          // gtag ID prod is G-KS2D10E44F
          // gtag ID dev is G-99Y78YWG6R
          {
            trackingId: gtagID,
            titleCase: false,
            gaOptions: {
              //name: "local",
              siteSpeedSampleRate: 100,
            },
          },
        ]);
      }
    }
  }, []);

  React.useEffect(() => {
    ga_initialize();
  }, [ga_initialize]);

  const ga_pageview = React.useCallback((location) => {
    if (process.env.NODE_ENV === "test") {
      return;
    }
    if (ReactGA) {
      ReactGA.set({ page: location }); // Update the user's current page
      ReactGA.send({ hitType: "pageview", page: location });
    }
  }, []);

  const ga_event = React.useCallback((category, action, label, location) => {
    //console.log("clicked", category, action, label, location);
    if (process.env.NODE_ENV === "test") {
      return;
    }
    if (ReactGA) {
      ReactGA.set({ page: location }); // Update the user's current page

      ReactGA.event(
        {
          category,
          action,
          label,
          transport: "beacon",
        },

        ["local"]
      );
    }
  }, []);

  const value = React.useMemo(
    () => ({ ga_pageview, ga_event }),
    [ga_pageview, ga_event]
  );
  return <GAContext.Provider value={value} {...props} />;
}

function useGA() {
  const context = React.useContext(GAContext);
  if (context === undefined) {
    throw new Error(`useGA must be used within GAProvider`);
  }
  return context;
}
export { GAProvider, useGA };
